import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import styles from './ConfirmCloseTicketModal.module.scss';

const ConfirmCloseTicketModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  ticketId, 
  ticketSubject 
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      className={styles.confirmModal}
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          <Icon icon="mdi:alert-circle" className={styles.warningIcon} />
          Confirmar Fechamento do Ticket
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className={styles.modalBody}>
        <div className={styles.warningMessage}>
          <Icon icon="mdi:information" className={styles.infoIcon} />
          <p>
            Tem certeza que deseja <strong>fechar este ticket</strong>?
          </p>
          <p className={styles.ticketInfo}>
            <strong>Ticket #{ticketId}:</strong> {ticketSubject}
          </p>
          <div className={styles.warningBox}>
            <Icon icon="mdi:alert" className={styles.alertIcon} />
            <span>Esta ação <strong>não pode ser desfeita</strong> e o ticket não aceitará mais respostas.</span>
          </div>
        </div>
      </Modal.Body>
      
      <Modal.Footer className={styles.modalFooter}>
        <Button 
          variant="outline-secondary" 
          onClick={onHide}
          className={styles.cancelButton}
        >
          <Icon icon="mdi:close" className="me-2" />
          Cancelar
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm}
          className={styles.confirmButton}
        >
          <Icon icon="mdi:close-circle" className="me-2" />
          Sim, Fechar Ticket
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmCloseTicketModal;
